module.exports = __webpack_public_path__ + "static/media/partner-icon-taptools-white.3e9a874d.svg";